import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import {
  buriedPagePoint,
  useInitBuriedPointInfo,
} from '../../../operationLog/buriedPoint';
import AIGalleryReportPage from '@/pages/opinion/operationLog/pages/AIGalleryReport';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { connect, useParams } from 'umi';
import usePageName from '@op/hooks/usePageName';
import { ThemeContext } from '@home/wrappers/common';
import { SYSTEM_THEME_DARK } from '@home/_config/config';
import useLanguage from '@op/hooks/useLanguage';
import LoadingCommon from '@op/components/LoadingCommon';
import './index.scss';

const themeToParam = (v: string): 'light' | 'dark' =>
  v === SYSTEM_THEME_DARK ? 'dark' : 'light';

const AI_GALLERY_TARGET_ORIGIN =
  typeof window !== 'undefined' ? window.location.origin : '*';

const buildInitialSrc = (
  rawPath: string,
  theme: 'light' | 'dark',
  lang: 'zh' | 'en',
): string => {
  const sep = rawPath.includes('?') ? '&' : '?';
  return `${rawPath}${sep}theme=${theme}&lang=${lang}`;
};

function AIGalleryReport({ listMenu, location }: any) {
  const params: any = useParams();
  const { pageName } = usePageName({ listMenu, menuId: params.reportId });
  const { themeValue } = useContext(ThemeContext);
  const { isEn } = useLanguage();
  const lang = isEn ? 'en' : 'zh';
  const theme = themeToParam(themeValue);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useInitBuriedPointInfo({
    buriedPoint: AIGalleryReportPage(
      pageName || location.pathname,
      location.pathname,
    ),
    triggerPagePoint: false,
  });

  const [loading, setLoading] = useState(true);
  const [reportUrl, setReportUrl] = useState('');

  useEffect(() => {
    setLoading(true);
    const { query } = location;
    setReportUrl(query.path);
  }, [location]);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (reportUrl) {
      buriedPagePoint();
    }
  }, [reportUrl]);

  const initialSrc = useMemo(() => {
    if (!reportUrl) return '';
    return buildInitialSrc(reportUrl, theme, lang);
    // 仅在 path 变化时重算 src（theme/lang 通过 postMessage 同步）
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportUrl]);

  useEffect(() => {
    if (!reportUrl) return;
    iframeRef.current?.contentWindow?.postMessage(
      { source: 'databrain-main-frame', type: 'theme', value: theme },
      AI_GALLERY_TARGET_ORIGIN,
    );
  }, [theme, reportUrl]);

  useEffect(() => {
    if (!reportUrl) return;
    iframeRef.current?.contentWindow?.postMessage(
      { source: 'databrain-main-frame', type: 'lang', value: lang },
      AI_GALLERY_TARGET_ORIGIN,
    );
  }, [lang, reportUrl]);

  return (
    <CardCommon
      contentCard
      empty={!initialSrc}
      bodyStyle={{ height: '100%' }}
      emptyHeight={550}
      className="dbo-aigallery-report"
    >
      {loading && (
        <LoadingCommon
          status="loading"
          isFullPage
        ></LoadingCommon>
      )}
      <iframe
        className='dbo-aigallery-report__iframe'
        src={initialSrc}
        title="ai-gallery-report"
        ref={iframeRef}
        onLoad={handleIframeLoad}
      />
    </CardCommon>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    listMenu: opinionCommon.listMenu,
  };
})(AIGalleryReport);
